export default __webpack_public_path__ + "static/media/plus.842b19f1.svg";